module.exports = __webpack_public_path__ + "static/img/CageJohn_lettertoGeorgeBrecht_27May1960.e3c7f52.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/brecht/archive/CageJohn_lettertoGeorgeBrecht_27May1960.jpg
// module id = 5r1d
// module chunks = 0